import { createDomWalker } from './utils';
var ElementTreeWalker = /** @class */ (function () {
    function ElementTreeWalker(root, filter) {
        this.walker = createDomWalker(root, function (node) { return filter(node); });
        this.currentElement = null;
    }
    Object.defineProperty(ElementTreeWalker.prototype, "root", {
        /**
         * Get root element
         */
        get: function () {
            return this.walker.root;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ElementTreeWalker.prototype, "current", {
        /**
         * Get current element
         */
        get: function () {
            return this.currentElement === this.root ? null : this.currentElement;
        },
        /**
         * Set current element
         */
        set: function (node) {
            var current = this.root.contains(node) ? node : null;
            this.currentElement = current;
            this.walker.currentNode = current !== null && current !== void 0 ? current : this.root;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Move to first element of root
     */
    ElementTreeWalker.prototype.first = function () {
        this.walker.currentNode = this.walker.root;
        return this.next();
    };
    /**
     * Move to last element of root
     */
    ElementTreeWalker.prototype.last = function () {
        this.walker.currentNode = this.walker.root;
        var descendant = null;
        while (this.walker.lastChild()) {
            descendant = this.walker.currentNode;
        }
        this.currentElement = descendant;
        return descendant;
    };
    /**
     * Move to next element of root
     */
    ElementTreeWalker.prototype.next = function () {
        this.currentElement = this.walker.nextNode();
        return this.currentElement;
    };
    /**
     * Move to previous element of root
     */
    ElementTreeWalker.prototype.previous = function () {
        var previous = this.walker.previousNode();
        this.currentElement = previous === this.root ? null : previous;
        return this.currentElement;
    };
    return ElementTreeWalker;
}());
export { ElementTreeWalker };
